var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_details_sec"},[_c('div',{staticClass:"w-12"},[_c('div',{staticClass:"icon_wrapper"},[_vm._t("default")],2)]),_c('div',[_c('span',{staticClass:"text-gray-400 uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_c('b',{staticClass:"font-[500]"},[_vm._v(_vm._s(_vm.value))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }